import { render, staticRenderFns } from "./CalendarSvgLoader.vue?vue&type=template&id=70db875b&scoped=true"
import script from "./CalendarSvgLoader.vue?vue&type=script&lang=js"
export * from "./CalendarSvgLoader.vue?vue&type=script&lang=js"
import style0 from "./CalendarSvgLoader.vue?vue&type=style&index=0&id=70db875b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70db875b",
  null
  
)

export default component.exports